/** UI cohorts only; controlled services independently enforce actor and scope. */
export const AGENCY_IN_CHARGE_UI_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'ROSTER_MANAGER',
  'FACILITY_MANAGER',
  'COORDINATOR',
  'TEAM_LEADER',
] as const;
export const AGENCY_REVIEW_UI_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CLINICAL_LEAD',
  'FACILITY_MANAGER',
  'ROSTER_MANAGER',
] as const;
export const AGENCY_ATTESTATION_UI_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CLINICAL_LEAD',
  'ROSTER_MANAGER',
] as const;
